import React from 'react';
import { getModelState } from 'client/data/luckdragon/model';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { parseContent } from 'client/data/cms/content';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { handle404Error } from 'site-modules/shared/utils/errors';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';
import { getMobileArticleContentPath } from 'site-modules/editorial/utils/content-path';
import { getMobileArticleBreadcrumbs } from 'site-modules/editorial/utils/breadcrumbs';
import { MobileArticle } from './mobile-article';

export const getPageOptions = articleId => ({
  name: `other_about_mobile_${articleId.replace(/-/g, '_')}`,
  category: 'other',
  preload: store => {
    const preloader = new ModelPreloader(store);

    const articlePath = getMobileArticleContentPath(articleId);
    preloader.resolve(`content["${articlePath}"]`, CmsModel);

    return preloader.load().then(modelState => {
      const article = modelState.get(`content["${articlePath}"]`, CmsModel);

      if (!(article && article.id)) {
        throw handle404Error({ errorMessage: `No content was found for ${articlePath}` });
      }

      return preloader.load();
    });
  },
  seo: state => {
    const modelState = getModelState(state);
    const articlePath = getMobileArticleContentPath(articleId);
    const content = parseContent(modelState.get(`content["${articlePath}"]`, CmsModel));

    return {
      ...getMeta(content),
      title: content.title,
      jsonld: [getBreadcrumbSchema(getMobileArticleBreadcrumbs({ title: content.title, articleId }))],
    };
  },
  component: () => <MobileArticle articleId={articleId} />,
  decorator: EdmundsCpaNoAdhesionDecorator,
});

export default ({ articleId }) => pageDefinition(getPageOptions(articleId));
